const fonts = {
  clearFace: {
    fontFamily: 'ITC Clearface Std',
    fontWeight: '400',
    fontStyle: 'normal',
  },
  maisonNeue: {
    fontFamily: 'MaisonNeue-Medium',
    fontWeight: '400',
    fontStyle: 'normal',
  },
  huge: {
    fontSize: 42,
    lineHeight: 42,
    letterSpacing: -1.4,
  },
  XL: {
    fontSize: 32,
    lineHeight: 36,
    letterSpacing: -1.4,
  },
  LG: {
    fontSize: 24,
    lineHeight: 24,
    letterSpacing: -1,
  },
  MD: {
    fontSize: 14,
    lineHeight: 19,
  },
  SM: {
    fontSize: 11,
    lineHeight: 16,
  },
  XS: {
    fontSize: 9,
    lineHeight: 11,
  },
};

export default fonts;
